export default "__VITE_ASSET__D2o5jd6l__"